module.exports = __webpack_public_path__ + "img/footer.d1a98d27.png";